import { OrderList } from 'api/general/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { EntityType } from 'store/entities/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<OrderList>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const orderReducer = createReducer<State, Actions>(initialState, {
  [actions.getOrder.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getOrder.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getOrder.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getOrder.reset.type]: actionsHandlers.handleGetOneReset,
});

export default orderReducer;
